import {
    PAYORDER_LIST_SUCCESS,
    PAYORDER_LIST_FAILED,
    PAYORDER_LIST_INVALID_REQUEST,
    PAYORDER_LIST_NOT_FOUND,
    PAYORDER_LIST_ACCOUNT_NOT_EXISTS,
    PAYORDER_LIST_INVALID_WALLET_OWNER_ID,
    PAYORDER_LIST_INVALID_CUSTOMER_ID,
    RESET_PAYORDER_LIST,
    LOADING_PAYORDER_LIST
} from "../types";

const initialState = {
    isLoading: false,
    success: false,
    failed: false,
    invalidRequest: false,
    notFound: false,
    accountNotExists: false,
    invalidCustomerID: false,
    invalidWalletOwnerId: false,
    data: {},
    message: ""
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_PAYORDER_LIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: false,
                accountNotExists: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                data: {},
                message: ""
            };
        case PAYORDER_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                invalidRequest: false,
                notFound: false,
                accountNotExists: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                data: action.payload,
                message: ""
            };
        case PAYORDER_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                invalidRequest: false,
                notFound: false,
                accountNotExists: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                data: action.payload,
                message: "Failed to load Pay Order List"
            };
        case PAYORDER_LIST_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: true,
                notFound: false,
                accountNotExists: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                data: action.payload,
                message: "Invalid Request"
            };
        case PAYORDER_LIST_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: true,
                accountNotExists: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                data: action.payload,
                message: "Pay Order List Not Found"
            };
        case PAYORDER_LIST_ACCOUNT_NOT_EXISTS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: false,
                accountNotExists: true,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                data: action.payload,
                message: "Account does not exist"
            };
        case PAYORDER_LIST_INVALID_WALLET_OWNER_ID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: false,
                accountNotExists: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: true,
                data: action.payload,
                message: "Invalid Wallet Owner ID"
            };
        case PAYORDER_LIST_INVALID_CUSTOMER_ID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: false,
                accountNotExists: false,
                invalidCustomerID: true,
                invalidWalletOwnerId: false,
                data: action.payload,
                message: "Invalid Customer ID"
            };
        case RESET_PAYORDER_LIST:
            return (state = initialState);

        default:
            return state;
    }
};
